import styled from 'styled-components'
import { COLOURS } from 'resources'
import RoundedButton from 'components/RoundedButton'

export const Container = styled.div`
  background-color: ${COLOURS.lightGrey6};
  border-radius: 4px;
  padding: 20px;
  width: 100%;
`

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
`

export const IconContainer = styled.div`
  background-color: ${({ color }) => color};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  width: 24px;
  height: 24px;
  border-radius: 100%;
  padding: 15px;
`

export const Icon = styled.img`
  width: 16px;
  height: 16px;
`

export const Title = styled.span`
  color: ${COLOURS.neutralBlack};
  font-family: Druk, sans-serif;
  font-size: 30px;
  line-height: 30px;
  padding-top: 5px;
  white-space: pre-wrap;
`

export const GreyTitle = styled(Title)`
  color: ${COLOURS.lightGrey4};
`

export const Description = styled.p`
  color: ${COLOURS.neutralBlack};
  font-family: 'EBGaramond', sans-serif;
  font-size: 12px;
  margin: 0;
  white-space: pre-wrap;
`

export const ItemWrapper = styled.div`
  border-bottom: 1px solid ${COLOURS.lightGrey7};
  :last-of-type {
    border-bottom: none;
  }
`

export const SeeMoreButton = styled(RoundedButton).attrs({
  variant: 'transparentPurple1',
  withArrow: true,
})`
  min-height: unset;
  width: 100%;
  font-size: 12px;
  border-radius: 4px;
  border: 1px solid ${COLOURS.secondaryPurple1};

  &.with-arrow {
    justify-content: center;
  }

  &.with-arrow .arrow {
    width: 20px;
  }

  &.arrow {
    width: 20px;
  }

  &:hover {
    border-color: ${COLOURS.secondaryPurple1};
  }
`
